import { Subscription, of } from 'rxjs';
import { DailyOrderService } from '@services/webFeeder/sckt-daily-order.service';
import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { SimpleOrder } from '@model/simpleOrder';
import { Constants } from '@utils/constants';
import { SideEnum } from '@model/enum/side.enum';
import { ConfigService } from '@services/webFeeder/config.service';
import { MatDialog } from '@angular/material/dialog';
import { BrokerAccount } from '@model/broker-account.model';
import { TypeOrderEnum } from '@model/enum/type-order.enum';
import { environment } from 'src/environments/environment';
import { AppUtils } from '@utils/app.utils';
import { TimeInForceEnum } from '@model/enum/time-in-force.enum';
import { TypeOrderRequestEnum } from '@model/enum/type-order-send.enum';


@Component({
  selector: 'app-billet-wks-confirmation',
  templateUrl: './billet-wks-confirmation.component.html'
})
export class BilletWksConfirmationComponent implements OnInit, OnDestroy {

  @Output() openConfirmationBillit = new EventEmitter<boolean>();
  @Output() openTermOperator = new EventEmitter<boolean>();
  @Output() loadingEmit = new EventEmitter<boolean>();
  @Input() model: SimpleOrder = new SimpleOrder();
  @Input() indiceFuture: boolean;
  @Input() lastTrade: number;
  @Input() isBilletFloat: boolean;

  public isLoginW = this._configService.isLoginTypeWSO2();
  // TODO: Desabilitado informações de financeiro na tela de ordens
  // public subscriptionMyBalance: Subscription;
  dialog: MatDialog;
  snapBalance: any = [];
  isAssessor: boolean;
  isStop: boolean;
  fullFlag = true;
  fractFlag = true;
  isRequest: boolean;
  accountSelectBroker: BrokerAccount = new BrokerAccount();
  accountBrokerList: any;
  limiteOperacional = '';
  termOperator: boolean;
  checkTermOperator: boolean;
  fractionary: number;
  fractionaryQtd: number;
  nonFractionaryQtd: number;
  nonFractionary: any;
  totalDisplay = 0;
  totalQtdDisplay = 0;
  loadingOrder: boolean;
  preventDoubleClick = false;
  titleMessageorder = Constants.BILLET_ORDER_SEND_01;
  fullFlagLoss = true;
  totalDisplayLoss = 0;
  nonFractionaryLoss: number;
  fractionaryLoss: number;
  fractionaryQtdLoss: number;
  nonFractionaryQtdLoss: number;
  fractionaryQtdGain: number;
  nonFractionaryQtdGain: number;
  nonFractionaryGain: number;
  totalDisplayGain = 0;
  fractionaryGain: number;
  fractFlagLoss = true;
  fullFlagGain = true;
  fractFlagGain = true;
  isOrderStopSimultaneous = this._configService.isTypeBilletStopSimultaneousOrOco();
  eletronicSignature: any = [];
  validSuitabilityOms = environment.SUITABILITY_OMS;
  brokerageValue: number;
  brokerageValueDisplay: string;
  totalDisplayBrokerage = 0;
  organization = this._configService.getConfigWhitelabel();
  isTypeOrderMarket: boolean;
  loginTypeEnable = this._configService.getLoginTypeEnabled();
  timeInForceEnum = TimeInForceEnum;
  subscriptionSendOrder: Subscription;
  subscriptionOrderSentSuccess: Subscription;
  orderSentSuccess = false;
  showFastBilletConfirmedOrder = environment.SHOW_FAST_BILLET_CONFIRMED_ORDER;

  get quotePrice(): string {
    if (!this.model.price) {
      return '';
    }
    return AppUtils.convertNumberToCurrency(this.model.price, this.model.priceTickSize);
  }

  constructor(
    _dialog: MatDialog,
    private _configService: ConfigService,
    private _dailyOrderService: DailyOrderService
  ) {
    this.dialog = _dialog;
    this.isAssessor = this._configService.isUserAssessorLogged();
    this.accountBrokerList = !this.isAssessor ? this._configService.getBrokerAccountList() : this._configService.getAssessorClientSelected();
    this.eletronicSignature = this._configService.getEletronicSignatureType();
    this.brokerageValue = Number(this._configService.getOrderBilletBrokerageValue());
    this.brokerageValueDisplay = this.brokerageValue ? this._configService.getOrderBilletBrokerageValue().replace('.', ',') : null;
    this.subscriptionOrderSentSuccess = this._dailyOrderService.orderSentSuccess$.subscribe(res => {
      if (res && this.showFastBilletConfirmedOrder) {
        this.orderSentSuccess = true;
        this.loadingOrder = false;
        this.loadingEmit.next(false);
        this.isRequest = false;
      }
    });
    this.subscriptionSendOrder = this._dailyOrderService.showHiddenPadOrderConfirmation$.subscribe(res => {
      if (res && !this.orderSentSuccess) {
        this.closeConfirmation(res);
      }
    });
  }

  ngOnInit() {
    this.model.account = this._configService.getBrokerAccountSelected();
    if (this.model && this.model.account) {
      // TODO: Desabilitado informações de financeiro na tela de ordens
      // this.subscribeFinancial(this.model.account);
      this.validConfirm();
    } else {
      this.callAlert('', Constants.WORKSPACE_MSG021, Constants.ALERT_TYPE.error);
      this.closeConfirmation();
    }

  }

  ngOnDestroy() {
    if (this.subscriptionSendOrder) {
      this.subscriptionSendOrder.unsubscribe();
    }
    if (this.subscriptionOrderSentSuccess) {
      this.subscriptionOrderSentSuccess.unsubscribe();
    }
    // TODO: Desabilitado informações de financeiro na tela de ordens
    // this.unSubscribeFinancial();
    // this.dialog.closeAll();
  }

  // TODO: desabilitado informações financeiras no moemnto
  // subscribeFinancial(account: string) {
  //   this._financialService.subscribeFinancial(account, Constants.TITLE_CARD_BILLET_QUICK);
  //   this.subscriptionMyBalance = this._financialService.messages
  //     .subscribe(data => {
  //       if (data) {
  //         if (this.snapBalance.length > 0) {
  //           let indexTemp;
  //           let posTemp;
  //           data.forEach(element => {
  //             this.snapBalance.find((x, index) => {
  //               if (x.account.toUpperCase() === element.account.toUpperCase()) {
  //                 indexTemp = index;
  //                 posTemp = element;
  //               }
  //             });
  //             if (posTemp && indexTemp >= 0) {
  //               this.snapBalance[indexTemp] = posTemp;
  //               posTemp = null;
  //               indexTemp = null;
  //             } else {
  //               this.snapBalance.push(element);
  //             }
  //           });
  //         } else {
  //           this.snapBalance = data;
  //         }
  //         this.updateBalance();
  //       }
  //     });
  // }

  // TODO: desabilitado informações financeiras no moemnto
  // updateBalance() {
  //   if (this.snapBalance && this.snapBalance.length > 0 && this.model.quote) {
  //     for (let i = 0; i < this.snapBalance.length; i++) {
  //       if (this.snapBalance[i].account.toLowerCase() === this.model.account.toLowerCase()) {
  //         this.snapBalance.filter(element => AppUtils.convertToCurrencyString(element.limiteOperacional) !== this.limiteOperacional)
  //           .forEach(elem => {
  //             elem.limiteOperacional = AppUtils.convertNumberToCurrency(Number(elem.limiteOperacional));
  //             this.limiteOperacional = elem.limiteOperacional;
  //           });
  //       }
  //     }
  //   }
  // }

  // TODO: desabilitado informações financeiras no moemnto
  // unSubscribeFinancial() {
  //   if (this._financialService && this.model.account) {
  //     this._financialService.unsubscribeFinancial(this.model.account, Constants.TITLE_CARD_BILLET_QUICK);
  //     if (this.subscriptionMyBalance) {
  //       this.subscriptionMyBalance.unsubscribe();
  //     }
  //   }
  // }

  validConfirm() {
    this.model.total = (this.model.price * this.model.qtd) / (AppUtils.convertNumberAux(this.model.quotationForm as any) * AppUtils.convertNumberAux(this.model.contractMultiplier as any))
    this.model.totalLoss = (this.model.stoptrigger * this.model.qtd) / (AppUtils.convertNumberAux(this.model.quotationForm as any) * AppUtils.convertNumberAux(this.model.contractMultiplier as any))
    this.model.totalGain = this.isOrderStopSimultaneous ? (this.model.targettrigger * this.model.qtd) / (AppUtils.convertNumberAux(this.model.quotationForm as any) * AppUtils.convertNumberAux(this.model.contractMultiplier as any)) : 0;

    if (!this.validateOpenConfirm()) {
      return;
    }
    if (this.model.type === TypeOrderEnum.MARKET || this.model.type === TypeOrderEnum.MARKETPROTECTED) {
      this.isTypeOrderMarket = true;
    } else {
      this.isTypeOrderMarket = false;
      this.isStop = this.model.type === TypeOrderEnum.STOP || this.model.type === TypeOrderEnum.STOP_LOSS ? true : false;
    }
    // TODO: Desabilitado informações de financeiro na tela de ordens
    // this.subscribeFinancial(this.model.account);
    if (this.model.qtd === 0) {
      this.callAlert('', Constants.BILLET_ORDER_MSG002, Constants.ALERT_TYPE.warn);
    } else {
      this.totalQtdDisplay = this.model.qtd;
      if (this.model.qtd % Number(this.model.loteDefault) === 0) {
        this.fractionaryQtd = 0;
        this.nonFractionaryQtd = this.model.qtd;
        this.nonFractionary = this.model.price ? this.model.total : 0;
        this.totalDisplay = this.totalDisplay + this.nonFractionary;

        console.log(this.totalDisplay);


        if (this.model.side === SideEnum.BUY) {
          this.totalDisplayBrokerage = this.brokerageValue ? this.totalDisplay + this.brokerageValue : null;
        } else {
          this.totalDisplayBrokerage = this.brokerageValue ? this.totalDisplay - this.brokerageValue : null;
        }

        this.fractionaryQtdGain = 0;
        this.nonFractionaryQtdGain = this.model.qtd;

        this.nonFractionaryGain = this.isOrderStopSimultaneous
          ? (Number(this.model.targettrigger) * this.model.qtd) / (this.model.quotationForm * this.model.contractMultiplier) : (Number(this.model.targetlimit) * this.model.qtd) / (this.model.quotationForm * this.model.contractMultiplier);

        this.totalDisplayGain = this.totalDisplayGain + this.nonFractionaryGain;
        this.fractionaryQtdLoss = 0;
        this.nonFractionaryQtdLoss = this.model.qtd;

        this.nonFractionaryLoss = (Number(this.model.stoptrigger) * this.model.qtd) / (this.model.quotationForm * this.model.contractMultiplier);

        this.totalDisplayLoss = this.totalDisplayLoss + this.nonFractionaryLoss;
      } else {
        this.fractionaryQtd = this.model.qtd - (this.model.qtd % Number(this.model.loteDefault));
        this.fractionaryQtd = this.model.qtd - this.fractionaryQtd;
        this.nonFractionaryQtd = this.model.qtd - this.fractionaryQtd;
        this.nonFractionary = this.model.price ? (this.nonFractionaryQtd * this.model.price) / (this.model.quotationForm * this.model.contractMultiplier) : 0;
        this.totalDisplay = this.totalDisplay + this.nonFractionary;
        this.fractionary = (this.fractionaryQtd * Number(this.model.price)) / (this.model.quotationForm * this.model.contractMultiplier)
        this.totalDisplay = this.totalDisplay + this.fractionary;
        console.log(this.totalDisplay);

        if (this.model.side === SideEnum.BUY) {
          this.totalDisplayBrokerage = this.brokerageValue ? this.totalDisplay + this.brokerageValue : null;
        } else {
          this.totalDisplayBrokerage = this.brokerageValue ? this.totalDisplay - this.brokerageValue : null;
        }

        this.fractionaryQtdGain = this.model.qtd - (this.model.qtd % Number(this.model.loteDefault));
        this.fractionaryQtdGain = this.model.qtd - this.fractionaryQtdGain;
        this.nonFractionaryQtdGain = this.model.qtd - this.fractionaryQtdGain;

        this.nonFractionaryGain = this.isOrderStopSimultaneous
          ? (this.nonFractionaryQtdGain * this.model.targettrigger) / (this.model.quotationForm * this.model.contractMultiplier) : (this.nonFractionaryQtdGain * this.model.targetlimit) / (this.model.quotationForm * this.model.contractMultiplier);


        this.totalDisplayGain = this.totalDisplayGain + this.nonFractionaryGain;

        this.fractionaryGain = this.isOrderStopSimultaneous
          ? (this.fractionaryQtdGain * this.model.targettrigger) / (this.model.quotationForm * this.model.contractMultiplier) : (this.fractionaryQtdGain * this.model.targetlimit) / (this.model.quotationForm * this.model.contractMultiplier);

        this.totalDisplayGain = this.totalDisplayGain + this.fractionaryGain;

        this.fractionaryQtdLoss = this.model.qtd - (this.model.qtd % Number(this.model.loteDefault));
        this.fractionaryQtdLoss = this.model.qtd - this.fractionaryQtdLoss;
        this.nonFractionaryQtdLoss = this.model.qtd - this.fractionaryQtdLoss;
        this.nonFractionaryLoss = (this.nonFractionaryQtdLoss * this.model.stoptrigger) / (this.model.quotationForm * this.model.contractMultiplier);
        this.totalDisplayLoss = this.totalDisplayLoss + this.nonFractionaryLoss;
        this.fractionaryLoss = (this.fractionaryQtdLoss * this.model.stoptrigger) / (this.model.quotationForm * this.model.contractMultiplier);
        this.totalDisplayLoss = this.totalDisplayLoss + this.fractionaryLoss;
      }
    }
  }

  validateOpenConfirm() {
    if (this.model.qtd == null || this.model.qtd === 0) {
      this.callAlert('', Constants.BILLET_ORDER_MSG002, Constants.ALERT_TYPE.warn);
      return false;
    }
    if (((this.model.price == null || this.model.price) && Number(this.model.price) <= 0)) {
      this.callAlert('', Constants.BILLET_ORDER_MSG006, Constants.ALERT_TYPE.warn);
      return false;
    }
    if (!this.model.quote || this.model.quote === '') {
      return false;
    }
    return true;
  }

  fullAssetFlag() {
    if (!this.fullFlag) {
      const elem = document.getElementById('order1');
      if (document.body.classList.contains('darkTheme')) {
        elem.style.color = 'white';
        elem.style.opacity = '0.6';
      } else {
        elem.style.color = 'black';
        elem.style.opacity = '0.6';
      }
      this.totalQtdDisplay = this.totalQtdDisplay - this.nonFractionaryQtd;
      this.totalDisplay = Number((this.totalDisplay - this.nonFractionary).toFixed(2));
      if (this.model.side === SideEnum.BUY) {
        this.totalDisplayBrokerage = this.brokerageValue ? this.totalDisplay + this.brokerageValue : null;
      } else {
        this.totalDisplayBrokerage = this.brokerageValue ? this.totalDisplay - this.brokerageValue : null;
      }
    } else {
      const elem = document.getElementById('order1');
      if (document.body.classList.contains('darkTheme')) {
        elem.style.color = '#2175ca';
        elem.style.opacity = '1';
      } else {
        elem.style.color = 'white';
        elem.style.opacity = '1';
      }
      this.totalQtdDisplay = this.totalQtdDisplay + this.nonFractionaryQtd;
      this.totalDisplay = this.totalDisplay + this.nonFractionary;
      if (this.model.side === SideEnum.BUY) {
        this.totalDisplayBrokerage = this.brokerageValue ? this.totalDisplay + this.brokerageValue : null;
      } else {
        this.totalDisplayBrokerage = this.brokerageValue ? this.totalDisplay - this.brokerageValue : null;
      }
    }
  }

  fractAssetFlag() {
    if (!this.fractFlag) {
      const elem = document.getElementById('order2');
      if (document.body.classList.contains('darkTheme')) {
        elem.style.color = 'white';
        elem.style.opacity = '0.6';
      } else {
        elem.style.color = 'black';
        elem.style.opacity = '0.6';
      }
      this.totalQtdDisplay = this.totalQtdDisplay - this.fractionaryQtd;
      this.totalDisplay = Number((this.totalDisplay - this.fractionary).toFixed(2));
      if (this.model.side === SideEnum.BUY) {
        this.totalDisplayBrokerage = this.brokerageValue ? this.totalDisplay + this.brokerageValue : null;
      } else {
        this.totalDisplayBrokerage = this.brokerageValue ? this.totalDisplay - this.brokerageValue : null;
      }
    } else {
      const elem = document.getElementById('order2');
      if (document.body.classList.contains('darkTheme')) {
        elem.style.color = '#2175ca';
        elem.style.opacity = '1';
      } else {
        elem.style.color = 'white';
        elem.style.opacity = '1';
      }
      this.totalQtdDisplay = this.totalQtdDisplay + this.fractionaryQtd;
      this.totalDisplay = this.totalDisplay + this.fractionary;
      if (this.model.side === SideEnum.BUY) {
        this.totalDisplayBrokerage = this.brokerageValue ? this.totalDisplay + this.brokerageValue : null;
      } else {
        this.totalDisplayBrokerage = this.brokerageValue ? this.totalDisplay - this.brokerageValue : null;
      }
    }
  }

  fullAssetFlagLoss() {
    if (!this.fullFlagLoss) {
      const elem = document.getElementById('order2');
      if (document.body.classList.contains('darkTheme')) {
        elem.style.color = 'white';
        elem.style.opacity = '0.6';
      } else {
        elem.style.color = 'black';
        elem.style.opacity = '0.6';
      }
      if (!this.fullFlagLoss && !this.fullFlagGain) {
        this.totalQtdDisplay = this.totalQtdDisplay - this.nonFractionaryQtdLoss;
      }
      this.totalDisplayLoss = Number((this.totalDisplayLoss - this.nonFractionaryLoss).toFixed(2));
    } else {
      const elem = document.getElementById('order2');
      if (document.body.classList.contains('darkTheme')) {
        elem.style.color = '#2175ca';
        elem.style.opacity = '1';
      } else {
        elem.style.color = 'white';
        elem.style.opacity = '1';
      }
      if (!this.fullFlagGain) {
        this.totalQtdDisplay = this.totalQtdDisplay + this.nonFractionaryQtdLoss;
      }
      this.totalDisplayLoss = this.totalDisplayLoss + this.nonFractionaryLoss;
    }
    this.totalQtdDisplay = this.totalQtdDisplay > 0 ? this.totalQtdDisplay : 0;
  }

  fractAssetFlagLoss() {
    if (!this.fractFlagLoss) {
      const elem = document.getElementById('order1');
      if (document.body.classList.contains('darkTheme')) {
        elem.style.color = 'white';
        elem.style.opacity = '0.6';
      } else {
        elem.style.color = 'black';
        elem.style.opacity = '0.6';
      }
      if (!this.fractFlagLoss && !this.fractFlagGain) {
        this.totalQtdDisplay = this.totalQtdDisplay - this.fractionaryQtdLoss;
      }
      this.totalDisplayLoss = Number((this.totalDisplayLoss - this.fractionaryLoss).toFixed(2));
    } else {
      const elem = document.getElementById('order1');
      if (document.body.classList.contains('darkTheme')) {
        elem.style.color = '#2175ca';
        elem.style.opacity = '1';
      } else {
        elem.style.color = 'white';
        elem.style.opacity = '1';
      }
      if (!this.fractFlagGain) {
        this.totalQtdDisplay = this.totalQtdDisplay + this.fractionaryQtdLoss;
      }
      this.totalDisplayLoss = this.totalDisplayLoss + this.fractionaryLoss;
    }
    this.totalQtdDisplay = this.totalQtdDisplay > 0 ? this.totalQtdDisplay : 0;
  }

  fullAssetFlagGain() {
    if (!this.fullFlagGain) {
      const elem = document.getElementById('order3');
      if (document.body.classList.contains('darkTheme')) {
        elem.style.color = 'white';
        elem.style.opacity = '0.6';
      } else {
        elem.style.color = 'black';
        elem.style.opacity = '0.6';
      }
      if (!this.fullFlagLoss && !this.fullFlagGain) {
        this.totalQtdDisplay = this.totalQtdDisplay - this.nonFractionaryQtdGain;
      }
      this.totalDisplayGain = Number((this.totalDisplayGain - this.nonFractionaryGain).toFixed(2));
    } else {
      const elem = document.getElementById('order3');
      if (document.body.classList.contains('darkTheme')) {
        elem.style.color = '#2175ca';
        elem.style.opacity = '1';
      } else {
        elem.style.color = 'white';
        elem.style.opacity = '1';
      }
      if (!this.fullFlagLoss) {
        this.totalQtdDisplay = this.totalQtdDisplay + this.nonFractionaryQtdGain;
      }
      this.totalDisplayGain = this.totalDisplayGain + this.nonFractionaryGain;
    }
    this.totalQtdDisplay = this.totalQtdDisplay > 0 ? this.totalQtdDisplay : 0;
  }

  fractAssetFlagGain() {
    if (!this.fractFlagGain) {
      const elem = document.getElementById('order4');
      if (document.body.classList.contains('darkTheme')) {
        elem.style.color = 'white';
        elem.style.opacity = '0.6';
      } else {
        elem.style.color = 'black';
        elem.style.opacity = '0.6';
      }
      if (!this.fractionaryGain) {
        this.fractionaryGain = 0;
      }
      if (!this.fractFlagLoss && !this.fractFlagGain) {
        this.totalQtdDisplay = this.totalQtdDisplay - this.fractionaryQtdGain;
      }
      this.totalDisplayGain = Number((this.totalDisplayGain - this.fractionaryGain).toFixed(2));
    } else {
      const elem = document.getElementById('order4');
      if (document.body.classList.contains('darkTheme')) {
        elem.style.color = '#2175ca';
        elem.style.opacity = '1';
      } else {
        elem.style.color = 'white';
        elem.style.opacity = '1';
      }
      if (!this.fractionaryGain) {
        this.fractionaryGain = 0;
      }
      if (!this.fractFlagGain) {
        this.totalQtdDisplay = this.totalQtdDisplay + this.fractionaryQtdGain;
      }
      this.totalDisplayGain = this.totalDisplayGain + this.fractionaryGain;
    }
    this.totalQtdDisplay = this.totalQtdDisplay > 0 ? this.totalQtdDisplay : 0;
  }
  /*
    _validSuitability(signature?) {
      this.isRequest = true;
      this.loadingEmit.next(true);
      this.loadingOrder = true;
      if (this.eletronicSignature && this.eletronicSignature.isActive && !this.validSignature && !this.model.signature && !this.isAssessor) {
        this.isRequest = false;
        this.loadingEmit.next(false);
        this.loadingOrder = false;
        this.callAlert('', Constants.BILLET_ORDER_EMPTY_SIGNATURE, Constants.ALERT_TYPE.warn);
        return false;
      }
      let accountSelectBrokerTemp: any = [];
      if (!this.isLoginW) {
        if (this.accountBrokerList && this.accountBrokerList.length >= 1) {
          this.accountBrokerList.forEach(element => {
            if (this.model && element.account === this.model.account && element.market === Constants.MARKET_BOVESPA && this.model.market === MarketEnum.BOVESPA) {
              accountSelectBrokerTemp = element;
            } else if (this.model && element.account === this.model.account && element.market === Constants.MARKET_BMF && this.model.market === MarketEnum.BMF) {
              accountSelectBrokerTemp = element;
            }
          });
        } else if (this.accountBrokerList && this.accountBrokerList.market === Constants.MARKET_BOVESPA && this.model && this.model.market === MarketEnum.BOVESPA) {
          accountSelectBrokerTemp = this.accountBrokerList;
        } else if (this.accountBrokerList && this.accountBrokerList.market === Constants.MARKET_BMF && this.model.market === MarketEnum.BMF) {
          accountSelectBrokerTemp = this.accountBrokerList;
        }
      } else if (this.isLoginW) {
        if (this.isAssessor) {
          accountSelectBrokerTemp = this.accountBrokerList.markets.find(x =>
            ((x === Constants.MARKET_BOVESPA || x === Constants.MARKET_BOVESPA2) && this.model && this.model.market === MarketEnum.BOVESPA) ||
            ((x === Constants.MARKET_BMF || x === Constants.MARKET_BMF2) && this.model.market === MarketEnum.BMF)
          );
          if (accountSelectBrokerTemp) {
            accountSelectBrokerTemp = this.accountBrokerList;
          }
        } else {
          if (this.accountBrokerList && this.accountBrokerList.length > 0) {
            this.accountBrokerList.forEach(element => {
              if ((element.market === Constants.MARKET_BOVESPA || element.market === Constants.MARKET_BOVESPA2) && this.model && this.model.market === MarketEnum.BOVESPA) {
                accountSelectBrokerTemp = element;
              } else if ((element.market === Constants.MARKET_BMF || element.market === Constants.MARKET_BMF2) && this.model.market === MarketEnum.BMF) {
                accountSelectBrokerTemp = element;
              }
            });
          } else {
            if (
              ((this.accountBrokerList.market === Constants.MARKET_BOVESPA || this.accountBrokerList.market === Constants.MARKET_BOVESPA2) && (this.model && this.model.market === MarketEnum.BOVESPA)) ||
              ((this.accountBrokerList.market === Constants.MARKET_BMF || this.accountBrokerList.market === Constants.MARKET_BMF2) && this.model.market === MarketEnum.BMF)
            ) {
              accountSelectBrokerTemp = this.accountBrokerList;
            }
          }
        }
      }
      if (!accountSelectBrokerTemp || (accountSelectBrokerTemp && accountSelectBrokerTemp.length === 0)) {
        const market = this.model.market === MarketEnum.BOVESPA ? 'Bovespa' : this.model.market === MarketEnum.BMF ? 'BMF' : ' do ativo selecionado.';
        this.callAlert('', 'Conta ' + this.model.account + ' não encontrada no mercado ' + market, Constants.ALERT_TYPE.error);
        this.isRequest = false;
        this.loadingOrder = false;
        this.loadingEmit.next(false);
        this.termOperator = false;
        return false;
      }
      this.accountSelectBroker = accountSelectBrokerTemp;
      if (this.accountSelectBroker.validateSuitability) {
        let profileName = '';
        let client_id = 0;
        let suitabilityID;
        if (this._configService.isLoginTypeWSO2() && this._configService.isUserAssessorLogged()) {
          profileName = this.accountBrokerList && this.accountBrokerList.profile_name ? this.accountBrokerList.profile_name : null;
          client_id = this.accountBrokerList && this.accountBrokerList.client_id ? this.accountBrokerList.client_id : null;
          suitabilityID = this.accountBrokerList && this.accountBrokerList.suitabilityID ? this.accountBrokerList.suitabilityID : null;
        } else {
          client_id = this._configService.getHbAccountId() ? Number(this._configService.getHbAccountId()) : null;
          profileName = this.accountSelectBroker && this.accountSelectBroker.profileName ? this.accountSelectBroker.profileName : null;
          suitabilityID = this.accountSelectBroker && this.accountSelectBroker.suitabilityID ? this.accountSelectBroker.suitabilityID : null;
        }
        if (!suitabilityID) {
          this.callAlert('', Constants.BILLET_ORDER_SEND_04, Constants.ALERT_TYPE.warn);
          this.isRequest = false;
          return false;
        }
        this._authServer.iSuitabilityService.suitabilityCheckMatrix(this.model.account, this.model.market,
          null, 0, this.model.quote, suitabilityID, profileName, client_id)
          .subscribe(res => {
            if (res && (res._isScalar === false || res.error === true || res.error === 'true')) {
              this.isRequest = false;
              this.loadingOrder = false;
              this.loadingEmit.next(false);
              this.termOperator = false;
              this.callAlert('', res.error_message ? res.error_message : Constants.BILLET_ORDER_SEND_05, Constants.ALERT_TYPE.error);
              return false;
            } else if (res && this._configService.isLoginTypeWSO2() && res.is_out_of_bounds === false && res._isScalar !== false) {

              if (this.model.side === SideEnum.BUY && (environment.ALWAYS_RE_SIGN_TERM_SUITABILITY_IN_BUY && (res.assign_bounds_id > 0))) {
                this._handleTerm(res, signature);
                return
              }
              if (this.model.side === SideEnum.SELL && (environment.ALWAYS_RE_SIGN_TERM_SUITABILITY_IN_SELL && (res.assign_bounds_id > 0))) {
                this._handleTerm(res, signature);
                return
              }

              this._emitOrder(signature);

            } else if (res.code && res.code.toString() === '200' && (res.message === 'true' || res.message === true)) {
              this._emitOrder(signature);
            } else if (res && !res.error && res.profile_framed) {
              this._emitOrder(signature);
            } else if (res && !res.error && ((res.view_term) || (!res.profile_framed && !res.is_signed))) {
              // debugger
              // TODO: MOCK API DE TERMOS DAYCOVAL
              const term = {
                type_term: this.loginTypeEnable === Constants.LOGIN_TYPE.LoginA ? res.type_term : Constants.TERM_OPERATOR_TYPES.TEXT,
                security_type: res.security_type || null,
                // pdf: res.term || null,
                pdf: res.mock_term || null,
                mock_html: res.mock_html,
                mock_link: res.mock_link,
                mock_text: res.mock_text
              };
              this.termOperator = true;
              this.loadingOrder = true;
              this.loadingEmit.next(this.loadingOrder);
              // this.openTermOperatorModal(term, signature);
              this._handleTerm(res, signature);
            } else if (res && !res.error && !res.view_term) {
              this.model.bypasssuitability = res.is_signed;
              this.termOperator = false;
              this._emitOrder(signature);
            } else if (res && ((res.is_out_of_bounds && res._isScalar !== false))
              || (res && res.code.toString() === '200' && (res.message === 'false' || res.message === false))) {

              this._handleTerm(res, signature);

            } else {
              this.isRequest = false;
              this.loadingOrder = false;
              this.loadingEmit.next(false);
              this.termOperator = false;
              this.callAlert('', Constants.BILLET_ORDER_SEND_05, Constants.ALERT_TYPE.error);
              this.openTermOperator.emit(this.termOperator);
              return false;
            }
          }, () => {
            this.isRequest = false;
            this.loadingOrder = false;
            this.loadingEmit.next(false);
            this.termOperator = false;
            this.openTermOperator.emit(this.termOperator);
            this.callAlert('', Constants.BILLET_ORDER_SEND_05, Constants.ALERT_TYPE.error);
            return false;
          });
      } else {
        this._emitOrder(signature);
      }
    }


    _handleTerm(res, signature) {
      const term = {
        type_term: this.loginTypeEnable === Constants.LOGIN_TYPE.LoginA ? res.type_term : Constants.TERM_OPERATOR_TYPES.TEXT,
        security_type: res.security_type || null,
        pdf: res.term || null
      };
      this.termOperator = true;
      this.loadingOrder = true;
      this.loadingEmit.next(this.loadingOrder);
      this.openTermOperator.emit(this.termOperator);
      this.openTermOperatorModal(term, signature);
    }


    _emitOrder(signature?) {
      this.preventDoubleClick = true;
      if (this.termOperator) {
        if (this.checkTermOperator) {
          this.model.bypasssuitability = this.checkTermOperator;
        } else {
          this.callAlert('', Constants.WORKSPACE_MSG023, Constants.ALERT_TYPE.warn);
          this.preventDoubleClick = false;
          this.checkTermOperator = false;
          this.loadingOrder = false;
          this.loadingEmit.next(false);
          this.isRequest = false;
          return false;
        }
      }
      if (!this._configService.isLoginTypeWSO2()) {
        this.loadingEmit.next(true);
        this.loadingOrder = true;
      }
      if (!this.model.market) {
        this.callAlert('', Constants.WORKSPACE_MSG020, Constants.ALERT_TYPE.warn);
        return false;
      }
      if (!this.model.account) {
        this.callAlert('', Constants.WORKSPACE_MSG021, Constants.ALERT_TYPE.warn);
        return false;
      }
      if (this.model.quote === null) {
        this.callAlert('', Constants.WORKSPACE_MSG005, Constants.ALERT_TYPE.warn);
        return false;
      }
      if (this.eletronicSignature && this.eletronicSignature.isActive && !this.validSignature && !this.isAssessor) {
        this.isRequest = false;
        this.callAlert('', Constants.BILLET_ORDER_VALID_SIGNATURE, Constants.ALERT_TYPE.error);
        return false;
      }
      let client_id = 0;
      let user_id = 0;
      if (this._configService.isLoginTypeWSO2() && this._configService.isUserAssessorLogged()) {
        client_id = this.accountBrokerList.client_id;
        user_id = Number(this._configService.getAssessorId());
      } else if (this._configService.isLoginTypeWSO2()) {
        client_id = Number(this._configService.getHbAccountId());
        user_id = Number(this._configService.getHbUserId());
      }
      if (!this.isStop) { // Ordem Simples
        this.sendOrderSingle(client_id, user_id, this.model.price, null, this.model.type, signature);
      } else { // Ordem Stop
        let priceTemp: any;
        let GainTrigger: string;
        let GainExecution: string;
        let LossTrigger: string;
        let LossExecution: string;
        if (this.fractFlag && !this.fullFlag) {
          this.model.qtd = this.fractionaryQtd;
          this.model.quote = this.model.quote.toLocaleUpperCase() + 'F';
        } else if (this.fullFlag && !this.fractFlag) {
          this.model.qtd = this.nonFractionaryQtd;
        }
        if (this.isOrderStopSimultaneous && this.isOrderStopSimultaneous && this.model.stopLoss && this.model.stopGain) {
          if (this.model.side === SideEnum.BUY) {
            LossTrigger = this.model.stoptrigger.toString();
            LossExecution = this.model.stoplimit.toString();
            GainTrigger = this.model.targettrigger.toString();
            GainExecution = this.model.targetlimit.toString();
          } else if (this.model.side === SideEnum.SELL) {
            GainTrigger = this.model.targettrigger.toString();
            GainExecution = this.model.targetlimit.toString();
            LossTrigger = this.model.stoptrigger.toString();
            LossExecution = this.model.stoplimit.toString();
          }
        } else if (this.isOrderStopSimultaneous && this.isOrderStopSimultaneous && this.model.stopGain) {
          // Only for up
          if (this.model.side === SideEnum.BUY) {
            LossTrigger = null;
            LossExecution = null;
            GainTrigger = this.model.targettrigger.toString();
            GainExecution = this.model.targetlimit.toString();
          } else if (this.model.side === SideEnum.SELL) {
            GainTrigger = this.model.targettrigger.toString();
            GainExecution = this.model.targetlimit.toString();
            LossTrigger = '0';
            LossExecution = '0';
          }
        } else {
          // Only for down
          if (!this.isOrderStopSimultaneous) {
            priceTemp = this.model.targetlimit;
          }
          if (this.model.side === SideEnum.BUY) {
            LossTrigger = this.model.stoptrigger.toString();
            LossExecution = this.model.stoplimit.toString();
            GainTrigger = '0';
            GainExecution = '0';
          } else if (this.model.side === SideEnum.SELL) {
            GainTrigger = null;
            GainExecution = null;
            LossTrigger = this.model.stoptrigger.toString();
            LossExecution = this.model.stoplimit.toString();
          }
        }
        this.model.clordlinkid = this.organization.billet.isTypeBilletStopSimultaneousOrOco === BilletOrderTypeEnum.OCO ?
          (this._configService.getBrokerAccount() + this._datePipe.transform(new Date(), 'yyyyMMddHHmmss')).toUpperCase() : null;
        this.sendOrderStop(client_id, user_id, GainTrigger, GainExecution, LossTrigger, LossExecution, priceTemp, this.model.clordlinkid, signature);
      }
    }
    */
  // validSuitability(signature?) {
  //   this.isRequest = true;
  //   this.loadingEmit.next(true);
  //   this.loadingOrder = true;
  //   if (this.eletronicSignature && this.eletronicSignature.isActive && !this.validSignature && !this.model.signature && !this.isAssessor) {
  //     this.isRequest = false;
  //     this.loadingEmit.next(false);
  //     this.loadingOrder = false;
  //     this.callAlert('', Constants.BILLET_ORDER_EMPTY_SIGNATURE, Constants.ALERT_TYPE.warn);
  //     return false;
  //   }
  //   let accountSelectBrokerTemp: any = [];
  //   if (!this.isLoginW) {
  //     if (this.accountBrokerList && this.accountBrokerList.length >= 1) {
  //       this.accountBrokerList.forEach(element => {
  //         if (this.model && element.account === this.model.account && element.market === Constants.MARKET_BOVESPA && this.model.market === MarketEnum.BOVESPA) {
  //           accountSelectBrokerTemp = element;
  //         } else if (this.model && element.account === this.model.account && element.market === Constants.MARKET_BMF && this.model.market === MarketEnum.BMF) {
  //           accountSelectBrokerTemp = element;
  //         }
  //       });
  //     } else if (this.accountBrokerList && this.accountBrokerList.market === Constants.MARKET_BOVESPA && this.model && this.model.market === MarketEnum.BOVESPA) {
  //       accountSelectBrokerTemp = this.accountBrokerList;
  //     } else if (this.accountBrokerList && this.accountBrokerList.market === Constants.MARKET_BMF && this.model.market === MarketEnum.BMF) {
  //       accountSelectBrokerTemp = this.accountBrokerList;
  //     }
  //   } else if (this.isLoginW) {
  //     if (this.isAssessor) {
  //       accountSelectBrokerTemp = this.accountBrokerList.markets.find(x =>
  //         ((x === Constants.MARKET_BOVESPA || x === Constants.MARKET_BOVESPA2) && this.model && this.model.market === MarketEnum.BOVESPA) ||
  //         ((x === Constants.MARKET_BMF || x === Constants.MARKET_BMF2) && this.model.market === MarketEnum.BMF)
  //       );
  //       if (accountSelectBrokerTemp) {
  //         accountSelectBrokerTemp = this.accountBrokerList;
  //       }
  //     } else {
  //       if (this.accountBrokerList && this.accountBrokerList.length > 0) {
  //         this.accountBrokerList.forEach(element => {
  //           if ((element.market === Constants.MARKET_BOVESPA || element.market === Constants.MARKET_BOVESPA2) && this.model && this.model.market === MarketEnum.BOVESPA) {
  //             accountSelectBrokerTemp = element;
  //           } else if ((element.market === Constants.MARKET_BMF || element.market === Constants.MARKET_BMF2) && this.model.market === MarketEnum.BMF) {
  //             accountSelectBrokerTemp = element;
  //           }
  //         });
  //       } else {
  //         if (
  //           ((this.accountBrokerList.market === Constants.MARKET_BOVESPA || this.accountBrokerList.market === Constants.MARKET_BOVESPA2) && (this.model && this.model.market === MarketEnum.BOVESPA)) ||
  //           ((this.accountBrokerList.market === Constants.MARKET_BMF || this.accountBrokerList.market === Constants.MARKET_BMF2) && this.model.market === MarketEnum.BMF)
  //         ) {
  //           accountSelectBrokerTemp = this.accountBrokerList;
  //         }
  //       }
  //     }
  //   }
  //   if (!accountSelectBrokerTemp || (accountSelectBrokerTemp && accountSelectBrokerTemp.length === 0)) {
  //     const market = this.model.market === MarketEnum.BOVESPA ? 'Bovespa' : this.model.market === MarketEnum.BMF ? 'BMF' : ' do ativo selecionado.';
  //     this.callAlert('', 'Conta ' + this.model.account + ' não encontrada no mercado ' + market, Constants.ALERT_TYPE.error);
  //     this.isRequest = false;
  //     this.loadingOrder = false;
  //     this.loadingEmit.next(false);
  //     this.termOperator = false;
  //     return false;
  //   }
  //   this.accountSelectBroker = accountSelectBrokerTemp;
  //   // debugger
  //   // TODO: MOCK API DE TERMOS DAYCOVAL
  //   // this.accountSelectBroker.validateSuitability = true;
  //   if (this.accountSelectBroker.validateSuitability) {
  //     let profileName = '';
  //     let client_id = 0;
  //     let suitabilityID;
  //     if (this._configService.isLoginTypeWSO2() && this._configService.isUserAssessorLogged()) {
  //       profileName = this.accountBrokerList && this.accountBrokerList.profile_name ? this.accountBrokerList.profile_name : null;
  //       client_id = this.accountBrokerList && this.accountBrokerList.client_id ? this.accountBrokerList.client_id : null;
  //       suitabilityID = this.accountBrokerList && this.accountBrokerList.suitabilityID ? this.accountBrokerList.suitabilityID : null;
  //     } else {
  //       client_id = this._configService.getHbAccountId() ? Number(this._configService.getHbAccountId()) : null;
  //       profileName = this.accountSelectBroker && this.accountSelectBroker.profileName ? this.accountSelectBroker.profileName : null;
  //       suitabilityID = this.accountSelectBroker && this.accountSelectBroker.suitabilityID ? this.accountSelectBroker.suitabilityID : null;
  //     }
  //     // debugger
  //     // TODO: MOCK API DE TERMOS DAYCOVAL
  //     // suitabilityID = 3;
  //     if (!suitabilityID) {
  //       this.callAlert('', Constants.BILLET_ORDER_SEND_04, Constants.ALERT_TYPE.warn);
  //       this.isRequest = false;
  //       return false;
  //     }
  //     this._authServer.iSuitabilityService.suitabilityCheckMatrix(this.model.account, this.model.market,
  //       null, 0, this.model.quote, suitabilityID, profileName, client_id)
  //       .subscribe(res => {
  //         if (res && (res._isScalar === false || res.error === true || res.error === 'true')) {
  //           this.isRequest = false;
  //           this.loadingOrder = false;
  //           this.loadingEmit.next(false);
  //           this.termOperator = false;
  //           this.callAlert('', res.error_message ? res.error_message : Constants.BILLET_ORDER_SEND_05, Constants.ALERT_TYPE.error);
  //           return false;
  //         } else if (res && this._configService.isLoginTypeWSO2() && res.is_out_of_bounds === false && res._isScalar !== false) {
  //           this._emitOrder(signature);
  //         } else if (res.code && res.code.toString() === '200' && (res.message === 'true' || res.message === true)) {
  //           this._emitOrder(signature);
  //         } else if (res && !res.error && res.profile_framed) {
  //           this._emitOrder(signature);
  //         } else if (res && !res.error && ((res.view_term) || (!res.profile_framed && !res.is_signed))) {
  //           // debugger
  //           // TODO: MOCK API DE TERMOS DAYCOVAL
  //           const term = {
  //             type_term: this.loginTypeEnable === Constants.LOGIN_TYPE.LoginA ? res.type_term : Constants.TERM_OPERATOR_TYPES.TEXT,
  //             security_type: res.security_type || null,
  //             // pdf: res.term || null,
  //             pdf: res.mock_term || null,
  //             mock_html: res.mock_html,
  //             mock_link: res.mock_link,
  //             mock_text: res.mock_text
  //           };
  //           this.termOperator = true;
  //           this.loadingOrder = true;
  //           this.loadingEmit.next(this.loadingOrder);
  //           this.openTermOperatorModal(term, signature);
  //         } else if (res && !res.error && !res.view_term) {
  //           this.model.bypasssuitability = res.is_signed;
  //           this.termOperator = false;
  //           this._emitOrder(signature);
  //         } else if (res && ((res.is_out_of_bounds && res._isScalar !== false))
  //           || (res && res.code.toString() === '200' && (res.message === 'false' || res.message === false))) {
  //           const term = {
  //             type_term: this.loginTypeEnable === Constants.LOGIN_TYPE.LoginA ? res.type_term : Constants.TERM_OPERATOR_TYPES.TEXT,
  //             security_type: res.security_type || null,
  //             pdf: res.term || null
  //           };
  //           this.termOperator = true;
  //           this.openTermOperator.emit(this.termOperator);
  //           this.openTermOperatorModal(term, signature);
  //         } else {
  //           this.isRequest = false;
  //           this.loadingOrder = false;
  //           this.loadingEmit.next(false);
  //           this.termOperator = false;
  //           this.callAlert('', Constants.BILLET_ORDER_SEND_05, Constants.ALERT_TYPE.error);
  //           this.openTermOperator.emit(this.termOperator);
  //           return false;
  //         }
  //       }, () => {
  //         this.isRequest = false;
  //         this.loadingOrder = false;
  //         this.loadingEmit.next(false);
  //         this.termOperator = false;
  //         this.openTermOperator.emit(this.termOperator);
  //         this.callAlert('', Constants.BILLET_ORDER_SEND_05, Constants.ALERT_TYPE.error);
  //         return false;
  //       });
  //   } else {
  //     this._emitOrder(signature);
  //   }
  // }

  // emitOrder(signature?) {
  //   this.preventDoubleClick = true;
  //   if (this.termOperator) {
  //     if (this.checkTermOperator) {
  //       this.model.bypasssuitability = this.checkTermOperator;
  //     } else {
  //       this.callAlert('', Constants.WORKSPACE_MSG023, Constants.ALERT_TYPE.warn);
  //       this.preventDoubleClick = false;
  //       this.checkTermOperator = false;
  //       this.loadingOrder = false;
  //       this.loadingEmit.next(false);
  //       this.isRequest = false;
  //       return false;
  //     }
  //   }
  //   if (!this._configService.isLoginTypeWSO2()) {
  //     this.loadingEmit.next(true);
  //     this.loadingOrder = true;
  //   }
  //   if (!this.model.market) {
  //     this.callAlert('', Constants.WORKSPACE_MSG020, Constants.ALERT_TYPE.warn);
  //     return false;
  //   }
  //   if (!this.model.account) {
  //     this.callAlert('', Constants.WORKSPACE_MSG021, Constants.ALERT_TYPE.warn);
  //     return false;
  //   }
  //   if (this.model.quote === null) {
  //     this.callAlert('', Constants.WORKSPACE_MSG005, Constants.ALERT_TYPE.warn);
  //     return false;
  //   }
  //   if (this.eletronicSignature && this.eletronicSignature.isActive && !this.validSignature && !this.isAssessor) {
  //     this.isRequest = false;
  //     this.callAlert('', Constants.BILLET_ORDER_VALID_SIGNATURE, Constants.ALERT_TYPE.error);
  //     return false;
  //   }
  //   let client_id = 0;
  //   let user_id = 0;
  //   if (this._configService.isLoginTypeWSO2() && this._configService.isUserAssessorLogged()) {
  //     client_id = this.accountBrokerList.client_id;
  //     user_id = Number(this._configService.getAssessorId());
  //   } else if (this._configService.isLoginTypeWSO2()) {
  //     client_id = Number(this._configService.getHbAccountId());
  //     user_id = Number(this._configService.getHbUserId());
  //   }
  //   if (!this.isStop) { // Ordem Simples
  //     this.sendOrderSingle(client_id, user_id, this.model.price, null, this.model.type, signature);
  //   } else { // Ordem Stop
  //     let priceTemp: any;
  //     let GainTrigger: string;
  //     let GainExecution: string;
  //     let LossTrigger: string;
  //     let LossExecution: string;
  //     if (this.fractFlag && !this.fullFlag) {
  //       this.model.qtd = this.fractionaryQtd;
  //       this.model.quote = this.model.quote.toLocaleUpperCase() + 'F';
  //     } else if (this.fullFlag && !this.fractFlag) {
  //       this.model.qtd = this.nonFractionaryQtd;
  //     }
  //     if (this.isOrderStopSimultaneous && this.isOrderStopSimultaneous && this.model.stopLoss && this.model.stopGain) {
  //       if (this.model.side === SideEnum.BUY) {
  //         LossTrigger = this.model.stoptrigger.toString();
  //         LossExecution = this.model.stoplimit.toString();
  //         GainTrigger = this.model.targettrigger.toString();
  //         GainExecution = this.model.targetlimit.toString();
  //       } else if (this.model.side === SideEnum.SELL) {
  //         GainTrigger = this.model.targettrigger.toString();
  //         GainExecution = this.model.targetlimit.toString();
  //         LossTrigger = this.model.stoptrigger.toString();
  //         LossExecution = this.model.stoplimit.toString();
  //       }
  //     } else if (this.isOrderStopSimultaneous && this.isOrderStopSimultaneous && this.model.stopGain) {
  //       // Only for up
  //       if (this.model.side === SideEnum.BUY) {
  //         LossTrigger = null;
  //         LossExecution = null;
  //         GainTrigger = this.model.targettrigger.toString();
  //         GainExecution = this.model.targetlimit.toString();
  //       } else if (this.model.side === SideEnum.SELL) {
  //         GainTrigger = this.model.targettrigger.toString();
  //         GainExecution = this.model.targetlimit.toString();
  //         LossTrigger = '0';
  //         LossExecution = '0';
  //       }
  //     } else {
  //       // Only for down
  //       if (!this.isOrderStopSimultaneous) {
  //         priceTemp = this.model.targetlimit;
  //       }
  //       if (this.model.side === SideEnum.BUY) {
  //         LossTrigger = this.model.stoptrigger.toString();
  //         LossExecution = this.model.stoplimit.toString();
  //         GainTrigger = '0';
  //         GainExecution = '0';
  //       } else if (this.model.side === SideEnum.SELL) {
  //         GainTrigger = null;
  //         GainExecution = null;
  //         LossTrigger = this.model.stoptrigger.toString();
  //         LossExecution = this.model.stoplimit.toString();
  //       }
  //     }
  //     this.model.clordlinkid = this.organization.billet.isTypeBilletStopSimultaneousOrOco === BilletOrderTypeEnum.OCO ?
  //       (this._configService.getBrokerAccount() + this._datePipe.transform(new Date(), 'yyyyMMddHHmmss')).toUpperCase() : null;
  //     this.sendOrderStop(client_id, user_id, GainTrigger, GainExecution, LossTrigger, LossExecution, priceTemp, this.model.clordlinkid, signature);
  //   }
  // }

  // sendOrderSingle(client_id, user_id, price, clordlinkid, typeOrder?, signature?) {
  //   if (!this._configService.isLoginTypeWSO2() && this.loginTypeEnable !== Constants.LOGIN_TYPE.LoginA) { // FACADE
  //     this._authServer.iNegotiation.sendOrderApi(this.model.account, this.model.quote, this.model.qtd, price.toString(), this.model.market,
  //       this.isOrderStopSimultaneous ? this.model.type : typeOrder, this.model.side, this.model.validityOrder, this.model.orderStrategy,
  //       this.model.timeInForces, this.model.orderid, this.model.origclordid, this.model.loteDefault,
  //       this.model.maxfloor > 0 ? `${this.model.maxfloor}` : null, this.model.minqtd > 0 ? `${this.model.minqtd}` : null,
  //       this.model.orderTag, this.model.bypasssuitability, clordlinkid)
  //       .subscribe(res => {
  //         if (res.code === 1) {
  //           if (res.message && res.message.split(';').length > 1) {
  //             const msg01 = JSON.parse(res.message.split(';')[0]);
  //             const msg02 = JSON.parse(res.message.split(';')[1]);
  //             if (msg01 && msg01.code === 1 && msg02 && msg02.code === 1) {
  //               this.callAlert('', 'Enviando orden(s) dos ativos ' + this.model.quote.toUpperCase() +
  //                 ' e ' + this.model.quote.toUpperCase() + 'F...', Constants.ALERT_TYPE.warn);
  //             }
  //           } else {
  //             this.callAlert('', this.titleMessageorder, Constants.ALERT_TYPE.warn);
  //           }
  //           this.closeConfirmation(true);
  //         } else if (res.code === 2) {
  //           if (res.message && res.message.split(';').length > 0) {
  //             const msg01 = JSON.parse(res.message.split(';')[0]);
  //             const msg02 = JSON.parse(res.message.split(';')[1]);
  //             if (msg01 && msg01.code === 1) {
  //               this.callAlert('', msg01.message, Constants.ALERT_TYPE.warn);
  //             } else {
  //               this.callAlert('', msg01.message, Constants.ALERT_TYPE.error);
  //             }
  //             if (msg02 && msg02.code === 1) {
  //               this.callAlert('', msg02.message, Constants.ALERT_TYPE.warn);
  //             } else {
  //               this.callAlert('', msg02.message, Constants.ALERT_TYPE.error);
  //             }
  //           }
  //           this.closeConfirmation(true);
  //         } else {
  //           if (res.code === 23) {
  //             this.endSession();
  //           } else {
  //             this.callAlert('', Constants.BILLET_ORDER_SEND_03, Constants.ALERT_TYPE.error);
  //           }
  //         }
  //         this.loadingOrder = false;
  //         this.loadingEmit.next(false);
  //         this.isRequest = false;
  //         this.termOperator = false;
  //         this.closeConfirmation(true);
  //       }, () => {
  //         this.isRequest = false;
  //         this.loadingOrder = false;
  //         this.loadingEmit.next(false);
  //         this.termOperator = false;
  //         this.closeConfirmation(true);
  //       });
  //   } else { // WSO2
  //     const sendSecondOrder = this.nonFractionaryQtd <= 0 ? false : true;
  //     const quotetemp = sendSecondOrder ? this.model.quote : this.model.quote + 'F';
  //     this._authServer.iNegotiation.sendOrderWso2(this.model.account, quotetemp, this.fractionaryQtd, this.nonFractionaryQtd,
  //       price.toString(), this.model.market, this.isOrderStopSimultaneous ? this.model.type : typeOrder, this.model.side,
  //       this.model.validityOrder, this.model.orderStrategy, this.model.timeInForces, this.model.orderid, this.model.origclordid,
  //       this.model.loteDefault, this.model.maxfloor > 0 ? `${this.model.maxfloor}` : null, this.model.minqtd > 0 ? `${this.model.minqtd}` : null,
  //       this.model.orderTag, null, null, null, null, false, this.model.bypasssuitability, clordlinkid, signature)
  //       .subscribe(res => {
  //         if (res.code === 1) {
  //           if (sendSecondOrder && this.fractionaryQtd > 0) {
  //             clordlinkid = this.organization.billet.isTypeBilletStopSimultaneousOrOco === BilletOrderTypeEnum.OCO ? clordlinkid + 'F' : null;
  //             this._authServer.iNegotiation.sendOrderWso2(this.model.account, this.model.quote + 'F', this.fractionaryQtd, 0,
  //               this.model.price.toString(), this.model.market, this.isOrderStopSimultaneous ? this.model.type : typeOrder, this.model.side,
  //               this.model.validityOrder, this.model.orderStrategy, this.model.timeInForces, this.model.orderid, this.model.origclordid,
  //               this.model.loteDefault, null, null, null, null, null, null, null, false, this.model.bypasssuitability, clordlinkid, signature)
  //               .subscribe(res2 => {
  //                 if (res2.code === 1) {
  //                   this.callAlert('', this.titleMessageorder, Constants.ALERT_TYPE.warn);
  //                 }
  //                 if (this.checkTermOperator && ((this._configService.isLoginTypeWSO2() && !this.validSuitabilityOms)
  //                   || this.loginTypeEnable === Constants.LOGIN_TYPE.LoginA)) {
  //                   this._authServer.iSuitabilityService.postAssignBounds(this.model.account, this.model.quote, client_id, user_id,
  //                     this.model.market, this.model.security_type)
  //                     .subscribe(res3 => {
  //                       if (res3) {
  //                         this.callAlert('', Constants.ORDER_HISTORY_MSG004, Constants.ALERT_TYPE.success);
  //                         this.checkTermOperator = false;
  //                       }
  //                     }, () => {
  //                       this.callAlert('', Constants.ORDER_HISTORY_MSG005, Constants.ALERT_TYPE.error);
  //                     });
  //                 }
  //                 this.isRequest = false;
  //                 this.termOperator = false;
  //                 this.openTermOperator.emit(this.termOperator);
  //               }, () => {
  //                 this.isRequest = false;
  //                 this.termOperator = false;
  //                 this.openTermOperator.emit(this.termOperator);
  //               });
  //           } else {
  //             this.callAlert('', this.titleMessageorder, Constants.ALERT_TYPE.warn);
  //             if (this.checkTermOperator && ((this._configService.isLoginTypeWSO2() && !this.validSuitabilityOms)
  //               || this.loginTypeEnable === Constants.LOGIN_TYPE.LoginA)) {
  //               this._authServer.iSuitabilityService.postAssignBounds(this.model.account, this.model.quote, client_id, user_id,
  //                 this.model.market, this.model.security_type)
  //                 .subscribe(res3 => {
  //                   if (res3) {
  //                     this.callAlert('', Constants.ORDER_HISTORY_MSG004, Constants.ALERT_TYPE.success);
  //                     this.checkTermOperator = false;
  //                   }
  //                 }, () => {
  //                   this.callAlert('', Constants.ORDER_HISTORY_MSG005, Constants.ALERT_TYPE.error);
  //                 });
  //             }
  //           }
  //           this.closeConfirmation(true);
  //           this.loadingOrder = false;
  //           this.loadingEmit.next(false);
  //           this.isRequest = false;
  //           this.termOperator = false;
  //         } else {
  //           if (res.code === 23) {
  //             this.endSession();
  //           } else {
  //             this.callAlert('', Constants.BILLET_ORDER_SEND_03, Constants.ALERT_TYPE.error);
  //           }
  //           this.isRequest = false;
  //           this.termOperator = false;
  //           this.closeConfirmation(true);
  //         }
  //       }, () => {
  //         this.loadingOrder = false;
  //         this.loadingEmit.next(false);
  //         this.isRequest = false;
  //         this.termOperator = false;
  //         this.closeConfirmation(true);
  //       });
  //   }
  // }

  // sendOrderStop(client_id, user_id, GainTrigger, GainExecution, LossTrigger, LossExecution, priceTemp, clordlinkid, signature?) {
  //   if (this.stopOrderValidator()) {
  //     if (!this._configService.isLoginTypeWSO2() && this.loginTypeEnable !== Constants.LOGIN_TYPE.LoginA) { // FACADE
  //       this._authServer.iNegotiation.sendOrderStopApi(this.model.account, this.model.validityOrder, this.model.orderStrategy,
  //         this.model.quote, this.model.qtd, GainTrigger, GainExecution, LossTrigger, LossExecution, this.model.market,
  //         this.model.side, this.model.timeInForces, this.model.orderid, this.model.origclordid, this.model.loteDefault, null,
  //         this.model.maxfloor > 0 ? `${this.model.maxfloor}` : null, this.model.minqtd > 0 ? `${this.model.minqtd}` : null,
  //         this.model.orderTag, this.model.bypasssuitability, clordlinkid)
  //         .subscribe(res => {
  //           if (res.code === 1) {
  //             if (res.message && res.message.split(';').length > 1) {
  //               const msg01 = JSON.parse(res.message.split(';')[0]);
  //               const msg02 = JSON.parse(res.message.split(';')[1]);
  //               if (msg01 && msg01.code === 1 && msg02 && msg02.code === 1) {
  //                 this.callAlert('', 'Enviando orden(s) dos ativos ' + this.model.quote.toUpperCase() +
  //                   ' e ' + this.model.quote.toUpperCase() + 'F...', Constants.ALERT_TYPE.warn);
  //               }
  //             } else {
  //               this.callAlert('', this.titleMessageorder, Constants.ALERT_TYPE.warn);
  //             }
  //             this.closeConfirmation(true);
  //           } else if (res.code === 2) {
  //             if (res.message && res.message.split(';').length > 0) {
  //               const msg01 = JSON.parse(res.message.split(';')[0]);
  //               const msg02 = JSON.parse(res.message.split(';')[1]);
  //               if (msg01 && msg01.code === 1) {
  //                 this.callAlert('', msg01.message, Constants.ALERT_TYPE.warn);
  //               } else {
  //                 this.callAlert('', msg01.message, Constants.ALERT_TYPE.error);
  //               }
  //               if (msg02 && msg02.code === 1) {
  //                 this.callAlert('', msg02.message, Constants.ALERT_TYPE.warn);
  //               } else {
  //                 this.callAlert('', msg02.message, Constants.ALERT_TYPE.error);
  //               }
  //             }
  //             this.closeConfirmation(true);
  //           } else {
  //             if (res.code === 23) {
  //               this.endSession();
  //             } else {
  //               this.callAlert('', Constants.BILLET_ORDER_SEND_03, Constants.ALERT_TYPE.error);
  //             }
  //           }
  //           if (!this.isOrderStopSimultaneous) {
  //             this.sendOrderSingle(client_id, user_id, priceTemp, clordlinkid, TypeOrderEnum.LIMITED);
  //           } else {
  //             this.loadingOrder = false;
  //             this.loadingEmit.next(false);
  //             this.isRequest = false;
  //             this.termOperator = false;
  //             this.closeConfirmation(true);
  //           }
  //         }, () => {
  //           this.isRequest = false;
  //           this.loadingOrder = false;
  //           this.loadingEmit.next(false);
  //           this.termOperator = false;
  //           this.closeConfirmation(true);
  //         });
  //     } else { // WSO2
  //       const sendSecondOrder = this.nonFractionaryQtd <= 0 ? false : true;
  //       const quotetemp = sendSecondOrder ? this.model.quote : this.model.quote + 'F';
  //       this._authServer.iNegotiation.sendOrderWso2(this.model.account, quotetemp, this.fractionaryQtd, this.nonFractionaryQtd,
  //         null, this.model.market, this.model.type, this.model.side, this.model.validityOrder, this.model.orderStrategy,
  //         this.model.timeInForces, this.model.orderid, this.model.origclordid, this.model.loteDefault,
  //         this.model.maxfloor > 0 ? `${this.model.maxfloor}` : null, this.model.minqtd > 0 ? `${this.model.minqtd}` : null,
  //         this.model.orderTag, GainTrigger, GainExecution, LossTrigger, LossExecution, true, this.model.bypasssuitability, clordlinkid,
  //         signature)
  //         .subscribe(res => {
  //           if (res.code === 1) {
  //             if (sendSecondOrder && this.fractionaryQtd > 0) {
  //               clordlinkid = this.organization.billet.isTypeBilletStopSimultaneousOrOco === BilletOrderTypeEnum.OCO ? clordlinkid + 'F' : null;
  //               this._authServer.iNegotiation.sendOrderWso2(this.model.account, this.model.quote + 'F', this.fractionaryQtd, 0, null,
  //                 this.model.market, this.model.type, this.model.side, this.model.validityOrder, this.model.orderStrategy,
  //                 this.model.timeInForces, this.model.orderid, this.model.origclordid, this.model.loteDefault, null, null, null,
  //                 GainTrigger, GainExecution, LossTrigger, LossExecution, true, this.model.bypasssuitability, clordlinkid, signature)
  //                 .subscribe(res2 => {
  //                   if (res2.code === 1) {
  //                     this.callAlert('', this.titleMessageorder, Constants.ALERT_TYPE.warn);
  //                   }
  //                   if (this.checkTermOperator && ((this._configService.isLoginTypeWSO2() && !this.validSuitabilityOms)
  //                     || this.loginTypeEnable === Constants.LOGIN_TYPE.LoginA)) {
  //                     this._authServer.iSuitabilityService.postAssignBounds(this.model.account, this.model.quote, client_id, user_id,
  //                       this.model.market, this.model.security_type)
  //                       .subscribe(res3 => {
  //                         if (res3) {
  //                           this.callAlert('', Constants.ORDER_HISTORY_MSG004, Constants.ALERT_TYPE.success);
  //                           this.checkTermOperator = false;
  //                         }
  //                       }, () => {
  //                         this.callAlert('', Constants.ORDER_HISTORY_MSG005, Constants.ALERT_TYPE.error);
  //                       });
  //                   }
  //                   this.isRequest = false;
  //                   this.termOperator = false;
  //                   this.openTermOperator.emit(this.termOperator);
  //                 }, () => {
  //                   this.isRequest = false;
  //                   this.termOperator = false;
  //                   this.openTermOperator.emit(this.termOperator);
  //                 });
  //             } else {
  //               this.callAlert('', this.titleMessageorder, Constants.ALERT_TYPE.warn);
  //               if (this.checkTermOperator && ((this._configService.isLoginTypeWSO2() && !this.validSuitabilityOms)
  //                 || this.loginTypeEnable === Constants.LOGIN_TYPE.LoginA)) {
  //                 this._authServer.iSuitabilityService.postAssignBounds(this.model.account, this.model.quote, client_id, user_id,
  //                   this.model.market, this.model.security_type)
  //                   .subscribe(res3 => {
  //                     if (res3) {
  //                       this.callAlert('', Constants.ORDER_HISTORY_MSG004, Constants.ALERT_TYPE.success);
  //                       this.checkTermOperator = false;
  //                     }
  //                   }, () => {
  //                     this.callAlert('', Constants.ORDER_HISTORY_MSG005, Constants.ALERT_TYPE.error);
  //                   });
  //               }
  //             }
  //             if (!this.isOrderStopSimultaneous) {
  //               this.sendOrderSingle(client_id, user_id, priceTemp, clordlinkid, TypeOrderEnum.LIMITED, signature);
  //             } else {
  //               this.closeConfirmation(true);
  //               this.loadingOrder = false;
  //               this.loadingEmit.next(false);
  //               this.isRequest = false;
  //               this.termOperator = false;
  //             }
  //           } else {
  //             if (res.code === 23) {
  //               this.endSession();
  //             } else {
  //               this.callAlert('', Constants.BILLET_ORDER_SEND_03, Constants.ALERT_TYPE.error);
  //             }
  //           }
  //           this.isRequest = false;
  //           this.termOperator = false;
  //           this.closeConfirmation(true);
  //         }, () => {
  //           this.loadingOrder = false;
  //           this.loadingEmit.next(false);
  //           this.isRequest = false;
  //           this.termOperator = false;
  //           this.closeConfirmation(true);
  //         });
  //     }
  //   } else {
  //     this.loadingOrder = false;
  //     this.loadingEmit.next(false);
  //     this.isRequest = false;
  //     this.termOperator = false;
  //     this.closeConfirmation(true);
  //   }
  // }

  stopOrderValidator() {
    if (this.model.side === Constants.ORDER_SIDE_BUY) {
      if (this.isOrderStopSimultaneous && this.model.stopGain) {
        if (Number(this.model.targettrigger) >= Number(this.lastTrade.toString().replace('.', '').replace(',', '.'))) {
          this.callAlert('', Constants.BILLET_ORDER_2_TRIGGER_BUY, Constants.ALERT_TYPE.warn);
          return false;
        }
        if (Number(this.model.targetlimit) < Number(this.model.targettrigger)) {
          this.callAlert('', Constants.BILLET_ORDER_2_LIMIT_BUY, Constants.ALERT_TYPE.warn);
          return false;
        }
      }
      if (this.model.stopLoss) {
        if (Number(this.model.stoptrigger) <= Number(this.lastTrade.toString().replace('.', '').replace(',', '.'))) {
          this.callAlert('', Constants.BILLET_ORDER_1_TRIGGER_BUY, Constants.ALERT_TYPE.warn);
          return false;
        }
        if (Number(this.model.stoplimit) < Number(this.model.stoptrigger)) {
          this.callAlert('', Constants.BILLET_ORDER_1_LIMIT_BUY, Constants.ALERT_TYPE.warn);
          return false;
        }
      }
      return true;
    } else if (this.model.side === Constants.ORDER_SIDE_SELL) {
      if (this.isOrderStopSimultaneous && this.model.stopGain) {
        if (Number(this.model.targettrigger) <= Number(this.lastTrade.toString().replace('.', '').replace(',', '.'))) {
          this.callAlert('', Constants.BILLET_ORDER_2_TRIGGER_SELL, Constants.ALERT_TYPE.warn);
          return false;
        }
        if (Number(this.model.targetlimit) > Number(this.model.targettrigger)) {
          this.callAlert('', Constants.BILLET_ORDER_2_LIMIT_SELL, Constants.ALERT_TYPE.warn);
          return false;
        }
      }
      if (this.model.stopLoss) {
        if (Number(this.model.stoptrigger) >= Number(this.lastTrade.toString().replace('.', '').replace(',', '.'))) {
          this.callAlert('', Constants.BILLET_ORDER_1_TRIGGER_SELL, Constants.ALERT_TYPE.warn);
          return false;
        }
        if (Number(this.model.stoplimit) > Number(this.model.stoptrigger)) {
          this.callAlert('', Constants.BILLET_ORDER_1_LIMIT_SELL, Constants.ALERT_TYPE.warn);
          return false;
        }
      }
      return true;
    }
  }

  callAlert(title, message, typeAlert) {
    this._configService.systemNotificationMessage(title, message, typeAlert);
    // TODO: abre o modal de ordens
    // alertMsg.click.subscribe((data) => {
    //   this._configService._clickOpenSideMenu.next(2);
    // });
  }

  confirmClose() {
    this.orderSentSuccess = false;
    this.closeConfirmation(true);
  }

  closeConfirmation(closeModal?: boolean) {
    this.loadingOrder = false;
    this.loadingEmit.next(false);
    this.preventDoubleClick = false;
    this.isRequest = false;
    this.termOperator = false;
    this.checkTermOperator = false;
    this.openTermOperator.emit(this.termOperator);
    this.openConfirmationBillit.emit(false);
    // TODO: Desabilitado informações de financeiro na tela de ordens
    // this.unSubscribeFinancial();
    if (closeModal) {
      this.dialog.closeAll();
    }
  }

  disableConfirmButton() {
    if ((!this.fullFlag && !this.fractFlag) || (!this.nonFractionary && !this.fractFlag) || (!this.fullFlag && this.fractionaryQtd === 0)) {
      return true;
    }
    return false;
  }

  verifyEletronicSignature() {
    if (this.model.type === TypeOrderEnum.STOP || this.model.type === TypeOrderEnum.STOP_LOSS) {
      this.stopOrderValidator();
    }
    this._dailyOrderService.verifyEletronicSignature(TypeOrderRequestEnum.SEND_ORDER, this.model);
  }

}
